export interface CubeBreakConfig {
  breakType: string;
  maxBreakTime: number;
  notifyOnExceed: number;
  workBreak: number;
  maxBreakLimit: number;
}

export const CUBE_BREAK_CONFIG: CubeBreakConfig[] = [
  { breakType: 'Bio Break', maxBreakTime: 999, notifyOnExceed: 0, workBreak: 0, maxBreakLimit: 0 },
  { breakType: 'Lunch Break', maxBreakTime: 999, notifyOnExceed: 0, workBreak: 0, maxBreakLimit: 0 },
  { breakType: 'Meeting Break', maxBreakTime: 999, notifyOnExceed: 0, workBreak: 1, maxBreakLimit: 0 },
  { breakType: 'Tea Break', maxBreakTime: 999, notifyOnExceed: 0, workBreak: 0, maxBreakLimit: 0 },
  { breakType: 'Training Break', maxBreakTime: 999, notifyOnExceed: 0, workBreak: 0, maxBreakLimit: 0 },
];

export const CUBE_BREAK_TYPES = CUBE_BREAK_CONFIG.map((b) => b.breakType) as [
  'Bio Break',
  'Lunch Break',
  'Meeting Break',
  'Tea Break',
  'Training Break',
];

export type CubeBreakType = (typeof CUBE_BREAK_TYPES)[number];

export const CUBE_BREAK_UI_OPTIONS = CUBE_BREAK_CONFIG.map((item, id) => ({
  name: item.breakType,
  id,
}));

const CUBE_BREAK_ICONS: Record<string, string> = {
  'Bio Break': 'wc',
  'Lunch Break': 'restaurant',
  'Meeting Break': 'groups',
  'Tea Break': 'local_cafe',
  'Training Break': 'school',
};

export function getCubeBreakIcon(breakType?: string): string {
  const key = resolveCubeBreakType(breakType);
  return CUBE_BREAK_ICONS[key] || 'free_breakfast';
}

export function resolveCubeBreakType(label?: string): CubeBreakType {
  const raw = String(label || '').trim();
  if (!raw) {
    return 'Tea Break';
  }
  const exact = CUBE_BREAK_TYPES.find((type) => type.toLowerCase() === raw.toLowerCase());
  return exact || 'Tea Break';
}

export function getCubeBreakConfig(label?: string): CubeBreakConfig {
  const type = resolveCubeBreakType(label);
  return (
    CUBE_BREAK_CONFIG.find((item) => item.breakType === type) ||
    CUBE_BREAK_CONFIG.find((item) => item.breakType === 'Tea Break') ||
    CUBE_BREAK_CONFIG[0]
  );
}

export function isCubeBreakType(label?: string): boolean {
  const raw = String(label || '').trim();
  if (!raw) {
    return false;
  }
  return CUBE_BREAK_TYPES.some((type) => type.toLowerCase() === raw.toLowerCase());
}

export function isCubeLoginBreak(label?: string): boolean {
  const raw = String(label || '').trim().toLowerCase();
  if (!raw) {
    return true;
  }
  return raw === 'login break' || raw === 'break' || raw === 'on break';
}
